import { SanityImageSource } from '@sanity/image-url/lib/types/types'
import { useMemo } from 'react'

import { getResizedImageUrl, ImageUrlOptions, tryParsingSanityImageJson } from '../utils'
import { useDeepMemo } from './../../../../src/hooks/useDeepMemo'

interface UseSanityImageSource {
  source?: SanityImageSource
  sourceJson?: string
}

type UseSanityImageHookOptions = ImageUrlOptions

const useSanityImage = (
  { source, sourceJson }: UseSanityImageSource,
  options: UseSanityImageHookOptions,
): string | null => {
  const urlOptions = useDeepMemo(() => options, [options])

  const derivedSource = useMemo(() => {
    return source || (sourceJson && tryParsingSanityImageJson(sourceJson))
  }, [source, sourceJson])

  return useMemo(
    () => (derivedSource ? getResizedImageUrl(derivedSource, urlOptions) : null),
    [derivedSource, urlOptions],
  )
}

export default useSanityImage
